import React from 'react';
import { Card, Button, Popconfirm, message } from 'antd';
import { $host } from '../../http';
import { deletePhoto } from '../../http/photoAPI';

const PhotoCard = ({ image, onDelete }) => {

    const handleDelete = async () => {
        try {
            await deletePhoto(image.id);
            message.success("Photo deleted successfully");
            if (onDelete) onDelete(image.id); // notify parent
        } catch (error) {
            message.error("Failed to delete photo");
        }
    }
    return (
    <Card
      hoverable
      style={{ width: 240 }}
      cover={
        <img
          draggable={false}
          alt="galery item"
          src={`${$host.defaults.baseURL}photos/${image.img_main}`}
        />
      }
      actions={[
        <Popconfirm
          key="delete"
          title="Are you sure to delete this photo?"
          onConfirm={handleDelete}
          okText="Yes"
          cancelText="No"
        >
          <Button danger type="text">
            Delete
          </Button>
        </Popconfirm>,
      ]}
    />
  );
};

export default PhotoCard;